module.exports = __webpack_public_path__ + "img/step2.20258628.png";